import gql from 'graphql-tag';

export const UpdateCoverPictureWidth = gql`
	mutation UpdateCoverPictureWidth($contentId: ID!, $coverPictureWidth: GraphQLCoverPictureWidth!) {
		updateCoverPictureWidth(
			input: { contentId: $contentId, coverPictureWidth: $coverPictureWidth }
		) {
			content {
				id
			}
		}
	}
`;
